module.exports = __webpack_public_path__ + "img/li.b6a090ac.svg";